<template>
	<v-card elevation="0" class="top-divider py-2">
		<v-row class="ma-0" align-content="center" align="center">
			<v-toolbar-title class="text-body-1 pl-0"> 並び替え項目 {{ count + 1 }} </v-toolbar-title>
			<v-row no-gutters justify="end">
				<v-menu offset-y close-on-click>
					<template v-slot:activator="{ on, attrs }">
						<v-btn text color="red" v-bind="attrs" v-on="on"> 削除 </v-btn>
					</template>
					<v-list>
						<v-list-item @click="$emit('delete-ledger-sort')">
							<v-list-item-title color="red" class="text-body-2">本当に削除する</v-list-item-title>
						</v-list-item>
					</v-list>
				</v-menu>
				<v-btn icon color="primary" @click="showForm = !showForm">
					<v-icon color="secondary" v-if="!showForm">mdi-chevron-down</v-icon>
					<v-icon color="secondary" v-else-if="showForm">mdi-chevron-up</v-icon>
				</v-btn>
			</v-row>
		</v-row>
		<div v-show="showForm">
			<!-- <v-select
				v-if="associationNames.length"
				v-model="ledgerSort.base_model"
				label="参照データ"
				:items="associationNames"
				class="mt-4"
				item-text="name"
				item-value="id"
				:persistent-hint="!ledgerSort.base_model"
				hint="選択しなければ台帳の参照データの項目から項目名を選択できます。"
				clearable
				dense
				outlined
				@change="setColumnNames"
			/> -->
			<v-select
				v-model="ledgerSort.column_name"
				label="項目名(必須)"
				ref="inputColumnName"
				:items="columnNameOptions"
				class="mt-4"
				item-text="name"
				item-value="id"
				:rules="[rules.required]"
				dense
				outlined
				@change="changeLedgerSort"
			/>
			<v-select
				v-model="ledgerSort.sort_type"
				label="並び替え順番(必須)"
				ref="inputSortType"
				:items="sortOptions"
				class="mt-4"
				item-text="name"
				item-value="id"
				:rules="[rules.required]"
				dense
				outlined
				@change="changeLedgerSort"
			/>
			<v-text-field
				v-model="ledgerSort.name"
				ref="inputName"
				label="表示名(必須)"
				class="mt-4"
				type="text"
				:rules="[rules.required]"
				dense
				outlined
				@change="changeLedgerSort"
			/>
		</div>
	</v-card>
</template>
<script>
import rules from "../../../helper/rules"

export default {
	props: {
		ledgerSortData: Object,
		originalModelColumns: Array,
		associationNames: Array,
		count: Number,
	},
	data() {
		return {
			ledgerSort: {
				uuid: null,
				// base_model: null,
				column_name: null,
				sort_type: null,
				name: null,
				value: null,
			},
			rules: rules,
			showForm: true,
			sortOptions: [
				{ id: "asc", name: "昇順" },
				{ id: "desc", name: "降順" },
			],
			// selectedModel: null,
		}
	},
	mounted() {
		this.ledgerSort = this.ledgerSortData
		this.$refs.inputColumnName.resetValidation()
		this.$refs.inputSortType.resetValidation()
		this.$refs.inputName.resetValidation()
	},
	methods: {
		// setColumnNames() {
		// 	this.selectedModel = this.associationNames.find(
		// 		(model) => this.ledgerSort.base_model == model.id
		// 	)
		// 	this.changeLedgerSort()
		// },
		changeLedgerSort() {
			if (this.ledgerSort.column_name && this.ledgerSort.sort_type) {
				this.ledgerSort.value = `${this.ledgerSort.column_name}_${this.ledgerSort.sort_type}`
			} else {
				this.ledgerSort.value = null
			}
			this.$emit("change-ledger-filter", this.ledgerSort)
		},
	},
	computed: {
		columnNameOptions() {
			if (this.selectedModel) {
				return this.selectedModel.columns.filter((c) => !c.meta_tag)
			} else {
				return this.originalModelColumns.filter((c) => !c.meta_tag)
			}
		},
	},
	watch: {
		ledgerSortData(newValue, _) {
			this.ledgerSort = newValue
		},
		deep: true,
	},
}
</script>

<style scoped lang="scss">
@import "../../../stylesheet/shared/color.scss";
.ledger-sort-form {
	padding: 8px;
	&:not(:first-child) {
		border-top: 1px solid whitesmoke;
	}
}
.v-toolbar__content {
	padding: 0;
}
</style>